"use strict";
export const initLines = async (selector) => {
    const firstElement = document.querySelector(selector);
    if (!firstElement) return;
	try {
        const module = await import('../modules/line-animation');
        module.initLines(selector);
	} catch (error) {
		console.error("Failed to load Line Animation dynamically:", error);
		return;
	}
}